import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  cmsOwnerId: belongsTo('user', { inverse: null }),
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  asset: belongsTo('asset', { inverse: null }),
  channel: belongsTo('channel', { inverse: null }),
  link: belongsTo('link', { inverse: null }),
  linkPatternDownload: hasMany('link-pattern', { inverse: null }),
  linkPatternMedium: hasMany('link-pattern', { inverse: null }),
  linkPatternStreaming: hasMany('link-pattern', { inverse: null }),
  linkPatternMerch: hasMany('link-pattern', { inverse: null }),
});
